<div *ngIf="vm$ | async as vm">
  <div class="heading-sub-regular mt-40">{{ 'settings.customize_notifications_txt' | translate }}</div>
  <div class="body-regular mt-12 mb-20">
    {{ 'settings.configure_notification_settings_txt' | translate }}
  </div>
  <div class="heading-sub-small mb-12">
    {{ 'settings.container_storage_period_in_ports_txt' | translate }}
  </div>

  <div class="box">

    <ng-container *ngIf="getNotificationMetric(vm, 'CN_EXTENDED_POO_STORAGE') as metrics">
      <div fxLayout="row">
        <div class="box-title w-200">{{ 'common.origin_port_txt' | translate }}</div>
        <div class="box-title w-200">{{ 'common.shipping_line_txt' | translate }}</div>
      </div>
      <!-- <div class="d-flex justify-content-between align-items-center">
        <button mat-button color="primary" (click)="currentMode = 'ADD_POO'" *ngIf="isAdmin">
          <mat-icon>add</mat-icon>
          <span>Customize a new port</span>
        </button>
      </div> -->

      <div *ngIf="currentMode === 'ADD_POO'">
        <dp-notification-metric-form-add [(currentMode)]="currentMode" [formData]="createDefaultFormData('CN_EXTENDED_POO_STORAGE')"
          [options]="{notificationCode: metrics.notificationCode, ports: ports, isAdmin: isAdmin}" (onDispatch)="onDispatch($event)">
        </dp-notification-metric-form-add>
        <mat-divider></mat-divider>
      </div>

      <ng-container *ngFor="let item of metrics.notificationMetrics; let i = index">
        <div *ngIf="!item.id || !deletedIds.has(item.id)">
          <mat-divider *ngIf="i !== 0"></mat-divider>
          <dp-notification-metric-form [(currentMode)]="currentMode" [formData]="item"
            [options]="{notificationCode: metrics.notificationCode, ports: ports, isAdmin: isAdmin}" (onDispatch)="onDispatch($event)">
          </dp-notification-metric-form>
        </div>
      </ng-container>

      <button mat-flat-button class="easy-button secondary" *ngIf="isAdmin" (click)="openCustomizePortDlg('ADD_POO', metrics)">{{ 'actions.customize_new_config_txt' | translate }}</button>

      <mat-divider></mat-divider>
    </ng-container>

    <br>

    <ng-container *ngIf="getNotificationMetric(vm, 'CN_EXTENDED_POD_STORAGE') as metrics">
      <div class="box-title">{{ 'common.destination_port_txt' | translate }}</div>
      <!-- <div class="d-flex justify-content-between align-items-center">
        <button mat-button color="primary" (click)="currentMode = 'ADD_POD'" *ngIf="isAdmin">
          <mat-icon>add</mat-icon>
          <span>Customize a new port</span>
        </button>
      </div> -->

      <div *ngIf="currentMode === 'ADD_POD'">
        <dp-notification-metric-form-add [(currentMode)]="currentMode" [formData]="createDefaultFormData('CN_EXTENDED_POD_STORAGE')"
          [options]="{notificationCode: metrics.notificationCode, ports: ports}" (onDispatch)="onDispatch($event)">
        </dp-notification-metric-form-add>
        <mat-divider></mat-divider>
      </div>

      <ng-container *ngFor="let item of metrics.notificationMetrics; let i = index">
        <div *ngIf="!item.id ||  !deletedIds.has(item.id)">
          <mat-divider *ngIf="i!==0"></mat-divider>
          <dp-notification-metric-form [(currentMode)]="currentMode" [formData]="item" (onDispatch)="onDispatch($event)"
            [options]="{notificationCode: metrics.notificationCode, ports: ports, isAdmin: isAdmin}">
          </dp-notification-metric-form>
        </div>
      </ng-container>
      <button mat-flat-button class="easy-button secondary" *ngIf="isAdmin" (click)="openCustomizePortDlg('ADD_POD', metrics)">{{ 'actions.customize_new_config_txt' | translate }}</button>

    </ng-container>

  </div>

  <section *ngIf="getNotificationMetric(vm, 'ARRIVING_SOON') as metrics">
    <div class="heading-sub-small mt-40 mb-12">{{ 'settings.hours_before_vessel_arrival_txt' | translate }}</div>
    <div class="box easy-form">
      <mat-form-field appearance="outline" class="w-60">
        <mat-label>{{ 'common.hours_txt' | translate }}</mat-label>
        <input matInput type="number" min="1" max="100" [value]="metrics.notificationMetrics[0].toleranceSecs / 3600"
          (change)="toleranceHoursChange($event, metrics.notificationMetrics[0])" [readonly]="!isAdmin">
      </mat-form-field>
    </div>
  </section>
</div>